import { Component, inject, input, OnInit } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { AnalysisConfigurationResponse } from '@api-response-types/analysis-configuration.response';
import { AnalysisVersionStatus } from '@api-types/enums/analysis-version-status.enum';
import { GridResetFiltersComponent } from '@components/table/grid-reset-filters/grid-reset-filters.component';
import { GridViewManagerComponent } from '@components/table/grid-view-manager/grid-view-manager.component';
import { PmErrorComponent } from '@libs/ui';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { AnalysisNavigationService } from 'demand-forecasting/analysis/services/analysis-navigation.service';
import { AnalysisStateService } from 'demand-forecasting/analysis/services/analysis-state.service';
import { selectAnalysisConfigurationIdByQueryParam } from 'demand-forecasting/store/router-state/router.selectors';
import { AnalysisBreadcrumbsComponent } from '../analysis-breadcrumbs/analysis-breadcrumbs.component';
import { AnalysisHeaderComponent } from '../analysis-header/analysis-header.component';
import { AnalysisProgressComponent } from '../analysis-progress/analysis-progress.component';
import { AnalysisTableComponent } from '../analysis-table/analysis-table.component';
import { AnalysisVersionMetadataComponent } from '../analysis-version-metadata/analysis-version-metadata.component';

@Component({
  selector: 'pm-analysis-content',
  templateUrl: './analysis-content.component.html',
  imports: [
    TranslateModule,
    AnalysisHeaderComponent,
    MatDividerModule,
    AnalysisVersionMetadataComponent,
    AnalysisTableComponent,
    AnalysisBreadcrumbsComponent,
    AnalysisProgressComponent,
    PmErrorComponent,
    GridViewManagerComponent,
    GridResetFiltersComponent,
  ],
  host: {
    class: 'block min-w-0 flex-grow h-full',
  },
})
export class AnalysisContentComponent implements OnInit {
  analysisConfigurations = input.required<AnalysisConfigurationResponse[]>();

  protected readonly AnalysisVersionStatus = AnalysisVersionStatus;

  private readonly analysisNavigationService = inject(
    AnalysisNavigationService,
  );

  protected readonly analysisStateService = inject(AnalysisStateService);

  private readonly store = inject(Store);

  private readonly analysisConfigurationId = this.store.selectSignal(
    selectAnalysisConfigurationIdByQueryParam,
  );

  ngOnInit() {
    const analysisConfigurationId = this.analysisConfigurationId();
    if (!analysisConfigurationId) {
      const configurations = this.analysisConfigurations();

      if (configurations.length < 1) {
        console.error('No analysis configurations available.');
        return;
      }

      const latestConfiguration = configurations[0];
      const latestVersion = latestConfiguration.latestAnalysisVersion;

      this.analysisNavigationService.setQueryParams({
        analysisConfigurationId: latestConfiguration.id,
        versionId: latestVersion?.id || null,
        filter: null,
        hierarchy: null,
      });
    }
  }
}
